import React from "react";
import { M44MediaViewer } from "../../../M44MediaViewer";
import { MediaViewerComponent } from "../../../MediaViewerComponent/MediaViewerComponent";
export const AnimationSection = ({ animationSrc, animationStateMachines, imageSrc, videoUrl, overlayMediaUrl, shouldBrowserPreload, }) => {
    const mediaOverlay = overlayMediaUrl && (React.createElement(M44MediaViewer, { mediaFileUrl: overlayMediaUrl, addDivWrapper: true, mediaClassname: "HeroBannerHomepageUplift__media-overlay" }));
    if (animationSrc && animationStateMachines) {
        return (React.createElement("div", { className: "HeroBannerHomepageUplift__media HeroBannerHomepageUplift__content__animation-container" },
            React.createElement(MediaViewerComponent, { src: animationSrc, stateMachines: animationStateMachines }),
            mediaOverlay));
    }
    if (imageSrc) {
        return (React.createElement("div", { className: "HeroBannerHomepageUplift__media HeroBannerHomepageUplift__image" },
            React.createElement(M44MediaViewer, { mediaFileUrl: imageSrc, addDivWrapper: false, shouldBrowserPreload: shouldBrowserPreload })));
    }
    if (videoUrl) {
        return (React.createElement("div", { className: "HeroBannerHomepageUplift__media HeroBannerHomepageUplift__video" },
            React.createElement(M44MediaViewer, { mediaFileUrl: videoUrl, addDivWrapper: false, shouldBrowserPreload: shouldBrowserPreload }),
            mediaOverlay));
    }
    return React.createElement(React.Fragment, null);
};
